import { render, staticRenderFns } from "./Corporatehub.vue?vue&type=template&id=58615d60"
import script from "./Corporatehub.vue?vue&type=script&lang=js"
export * from "./Corporatehub.vue?vue&type=script&lang=js"
import style0 from "./Corporatehub.vue?vue&type=style&index=0&id=58615d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports